import { LOGOUT } from "@constants/routes";
import PasswordField from "@easydev/form/Password";
import lockScreenValidate from "@validators/Security/Account/LockScreen.validate";
import AlertCircleOutlineIcon from "mdi-react/AlertCircleOutlineIcon";
import PropTypes from "prop-types";
import { Field, Form } from "react-final-form";
import { NavLink } from "react-router-dom";
import { Alert, Button } from "reactstrap";

const LockScreenForm = ({ onSubmit, errorMessage = "" }) => (
  <Form onSubmit={onSubmit} validate={lockScreenValidate}>
    {({ handleSubmit }) => (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group form__form-group--forgot">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field">
            <Field
              name="password"
              component={PasswordField}
              placeholder={"Password"}
              className="input-without-border-radius"
              keyIcon
              isAboveError
            />
          </div>
        </div>
        <Alert className="account__btn" color="danger" isOpen={!!errorMessage}>
          <AlertCircleOutlineIcon /> {errorMessage}
        </Alert>
        <Button className="account__btn" color="primary" type="submit">
          Unlock
        </Button>
        <NavLink className="btn btn-outline-danger account__btn" to={LOGOUT}>
          Log out
        </NavLink>
      </form>
    )}
  </Form>
);

LockScreenForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

export default LockScreenForm;
